import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { AccountIndexComponent } from './account-index/account-index.component';
import {RouterModule} from '@angular/router';
import {AccountRoutesModule} from './account-routes/account-routes.module';
import {TableAccountModule} from '../../resources/tables/table-account/table-account.module';
import {CardModule} from '../../resources/components/card/card.module';
import { AccountViewComponent } from './account-view/account-view.component';
import {TableUserModule} from '../../resources/tables/table-user/table-user.module';
import {TableProductModule} from '../../resources/tables/table-product/table-product.module';
import {TableDeviceModule} from '../../resources/tables/table-device/table-device.module';
import {TableStoreModule} from '../../resources/tables/table-store/table-store.module';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import {TableProjectModule} from '../../resources/tables/table-project/table-project.module';
import { AccountViewUsersComponent } from './account-view/account-view-users/account-view-users.component';
import { AccountViewPurchasesComponent } from './account-view/account-view-purchases/account-view-purchases.component';
import { AccountViewProjectsComponent } from './account-view/account-view-projects/account-view-projects.component';
import { AccountViewInfoComponent } from './account-view/account-view-info/account-view-info.component';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {BadgeExistModule} from '../../resources/components/badge-exist/badge-exist.module';
import {EntityLinkModule} from "../../resources/components/entity-link/entity-link.module";
import {SharedModule} from "../../modules/shared.module";
import {RouterOuterDirectiveModule} from "../../resources/directives/router-outer-directive/router-outer-directive.module";
import {TabsRouteModule} from "../../resources/components/tabs-route/tabs-route.module";



@NgModule({
  declarations: [
    AccountComponent,
    AccountIndexComponent,
    AccountViewComponent,
    AccountViewUsersComponent,
    AccountViewPurchasesComponent,
    AccountViewProjectsComponent,
    AccountViewInfoComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    AccountRoutesModule,
    TableAccountModule,
    TableUserModule,
    TableProductModule,
    TableDeviceModule,
    TableStoreModule,
    TablePurchaseModule,
    TableProjectModule,
    FormGroupContextModule,
    BadgeExistModule,
    EntityLinkModule,
    SharedModule,
    RouterOuterDirectiveModule,
    TabsRouteModule
  ]
})
export class AccountModule { }
